import React, { useEffect, useState } from "react";
import "./App.css";
import LoginScreen from "./components/LoginScreen";
import SignUpScreen from "./components/SignUpScreen";
import ConfirmCodeScreen from "./components/ConfirmCodeScreen";
import StudentConfirmOTP from "./components/StudentConfirmOTP";
import ChangeConfirmationMethod from "./components/ChangeConfirmationMethod";
import HomeScreen from "./components/HomeScreen";
import SearchResultsScreen from "./components/SearchResultsScreen";
import ProductDetailsScreen from "./components/ProductDetailsScreen";
import CartScreen from "./components/CartScreen";
import CheckoutScreen from "./components/CheckoutScreen";
import ProfileScreen from "./components/ProfileScreen";
import OrdersScreen from "./components/OrderScreen";
import ViewOrderProductScreen from "./components/ViewOrderProductScreen";
import AddressScreen from "./components/AddressScreen";
import AddNewAddressScreen from "./components/AddNewAddressScreen";
import EditAddressScreen from "./components/EditAddressScreen";
import CustomerCareScreen from "./components/CustomerCareScreen";
import CategoryScreen from "./components/CategoryScreen";
import CategoryProductsScreen from "./components/CategoryProductsScreen";
import VendorLoginScreen from "./components/VendorLoginScreen";
import VendorSignupScreen from "./components/VendorSignupScreen";
import StudentResellerHome from "./components/StudentResellerHome";
import StudentResellerScreen from "./components/StudentResellerScreen";
import AddAccount from "./components/AddAccount";
import CongratulationsScreen from "./components/CongratulationsScreen";
import VendorHomeScreen from "./components/VendorHomeScreen";
import ProductScreen from "./components/ProductScreen";
import ViewSingleProduct from "./components/ViewSingleProduct";
import EditProductScreen from "./components/EditProductScreen";
import VendorOrdersScreen from "./components/VendorOrdersScreen";
import ViewOrder from "./components/ViewOrder";
import MenuScreen from "./components/MenuScreen";
import AddProductsScreen from "./components/AddProductsScreen";
import VendorAddProductScreen from "./components/VendorAddProductScreen";
import PaymentScreen from "./components/PaymentScreen";
import PaymentSettingsScreen from "./components/PaymentSettingsScreen";
import EditPaymentSettingsScreen from "./components/EditPaymentSettingsScreen";
import AdminLoginScreen from "./components/AdminLoginScreen";
import VendorSectionScreen from "./components/VendorSection";
import VendorDetailsScreen from "./components/VendorDetailsScreen";
import AdminViewOrdersScreen from "./components/AdminViewOrdersScreen";
import ConfirmOrderScreen from "./components/ConfirmOrder";
import LogisticRiderLoginScreen from "./components/LogisticRiderLoginScreen";
import LogisticRiderCreateAccount from "./components/LogisticRiderCreateAccount";
import LogisticHomeScreen from "./components/LogisticHomeScreen";
import LogisticOrderGroup from "./components/LogisticOrderGroup";
import LogisticViewDeliveryOrders from "./components/LogisticViewDeliveryOrders";
import LogisticRiderViewOrderStatusInGroup from "./components/LogisticRiderViewOrderStatusInGroup";
import ConfirmDeliveryScreen from "./components/ConfirmDeliveryScreen";
import LogisticProfileScreen from "./components/LogisticProfileScreen";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { IoWifiOutline } from "react-icons/io5";

function App() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const handleReload = () => {
    setIsOnline(navigator.onLine);
  };

  return (
    <div className="App">
      <BrowserRouter>
        {!isOnline && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-white">
            <div className="flex flex-col items-center">
              <div className="relative">
                <IoWifiOutline className="h-20 w-20 text-[#19C463]" />
                <span className="absolute left-1/2 top-1/2 h-1 w-16 -translate-x-1/2 -translate-y-1/2 -rotate-45 bg-[#19C463]" />
              </div>
              <p className="mt-4 text-base font-semibold text-gray-900">
                No internet connection
              </p>
              <button
                type="button"
                onClick={handleReload}
                className="mt-4 rounded-lg bg-[#19C463] px-6 py-2 text-sm font-semibold text-white"
              >
                Reload
              </button>
            </div>
          </div>
        )}
        <Routes>
          <Route path="/" element={<Navigate to="/home" replace />} />
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/signup" element={<SignUpScreen />} />
          <Route path="/confirm" element={<ConfirmCodeScreen />} />
          <Route path="/student-confirm-otp" element={<StudentConfirmOTP />} />
          <Route path="/change-method" element={<ChangeConfirmationMethod />} />
          <Route path="/home" element={<HomeScreen />} />
          <Route path="/search" element={<SearchResultsScreen />} />
          <Route path="/product/:productId" element={<ProductDetailsScreen />} />
          <Route path="/product" element={<ProductDetailsScreen />} />
          <Route path="/cart" element={<CartScreen />} />
          <Route path="/checkout" element={<CheckoutScreen />} />
          <Route path="/profile" element={<ProfileScreen />} />
          <Route path="/orders" element={<OrdersScreen />} />
          <Route path="/view-order/:orderItemId" element={<ViewOrderProductScreen />} />
          <Route path="/view-order" element={<ViewOrderProductScreen />} />
          <Route path="/address" element={<AddressScreen />} />
          <Route path="/add-address" element={<AddNewAddressScreen />} />
          <Route path="/edit-address" element={<EditAddressScreen />} />
          <Route path="/customer-care" element={<CustomerCareScreen />} />
          <Route path="/category" element={<CategoryScreen />} />
          <Route path="/category/:name" element={<CategoryProductsScreen />} />
          <Route path="/vendor-login" element={<VendorLoginScreen />} />
          <Route path="/vendor-signup" element={<VendorSignupScreen />} />
          <Route path="/student-reseller" element={<StudentResellerHome />} />
          <Route path="/student-reseller-signup" element={<StudentResellerScreen />} />
          <Route path="/add-account-details" element={<AddAccount />} />
          <Route path="/congratulations" element={<CongratulationsScreen />} />
          <Route path="/vendor-home" element={<VendorHomeScreen />} />
          <Route path="/products" element={<ProductScreen />} />
          <Route path="/view-single-product/:productId" element={<ViewSingleProduct />} />
          <Route path="/view-single-product" element={<ViewSingleProduct />} />
          <Route path="/edit-product" element={<EditProductScreen />} />
          <Route path="/vendor-orders" element={<VendorOrdersScreen />} />
          <Route path="/view-order-vendor/:orderItemId" element={<ViewOrder />} />
          <Route path="/menu" element={<MenuScreen />} />
          <Route path="/add-products" element={<AddProductsScreen />} />
          <Route path="/add-product" element={<VendorAddProductScreen />} />
          <Route path="/payment" element={<PaymentScreen />} />
          <Route path="/payment-settings" element={<PaymentSettingsScreen />} />
          <Route path="/edit-payment-settings" element={<EditPaymentSettingsScreen />} />
          <Route path="/buyit-force" element={<AdminLoginScreen />} />
          <Route path="/vendor-section" element={<VendorSectionScreen />} />
          <Route path="/vendor-details/:id" element={<VendorDetailsScreen />} />
          <Route path="/vendor-details" element={<VendorDetailsScreen />} />
          <Route path="/admin-view-orders" element={<AdminViewOrdersScreen />} />
          <Route path="/confirm-order-vendor-admin/:orderItemId" element={<ConfirmOrderScreen />} />
          <Route path="/confirm-order-vendor-admin" element={<ConfirmOrderScreen />} />
          <Route path="/logistic-rider-login" element={<LogisticRiderLoginScreen />} />
          <Route path="/create-logistic-rider-account" element={<LogisticRiderCreateAccount />} />
          <Route path="/logistic-home" element={<LogisticHomeScreen />} />
          <Route path="/view-order-group" element={<LogisticOrderGroup />} />
          <Route path="/logistic-deliveries" element={<LogisticViewDeliveryOrders />} />
          <Route path="/view-orders-deliveries" element={<LogisticRiderViewOrderStatusInGroup />} />
          <Route path="/logistic-confirm-delivery" element={<ConfirmDeliveryScreen />} />
          <Route path="/logistic-profile" element={<LogisticProfileScreen />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
